import IndexVM from './index-vm';
import Vue from 'vue';
import 'libs/vue-extensions';
export default {
  init: function (element) {
    console.log('CourseworkListView initialization function called');
    let vm = new Vue(IndexVM);
    vm.bindData(JSON.parse(element.dataset.jobsJson));
    vm.$mount(element);
  }
};

